import { render, staticRenderFns } from "./case1.vue?vue&type=template&id=4ce7bc6c&scoped=true&"
import script from "./case1.vue?vue&type=script&lang=js&"
export * from "./case1.vue?vue&type=script&lang=js&"
import style0 from "./case1.vue?vue&type=style&index=0&id=4ce7bc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce7bc6c",
  null
  
)

export default component.exports